import { toast } from "react-hot-toast";

/**
 * @function TOAST
 * @description TOASTS FOR DIFFERENT ACTIONS
 */

const SHOW_TOAST = (message = "OOPS! something went wrong") => {
  toast.dismiss();
  toast.error(message);
};
export const ERROR_TOAST = (message = "OOPS! something went wrong") => {
  toast.dismiss();
  toast.error(message);
};
export const SHOW_INTERNET_TOAST = () => {
  toast.dismiss();
  toast.error("Please check your internet connections.");
};

export const LOGOUT_TOAST = () => {
  toast.dismiss();
  toast.success("Logout Successful");
};
export const SUCCESS_TOAST = (message = "Action Successful") => {
  toast.dismiss();
  toast.success(message);
};
export default SHOW_TOAST;
